/* eslint-disable react/no-unescaped-entities */
import React from 'react'
import Section from '../components/Section'

class LoginForms extends React.Component {
	toggleForms = () => {
		const overlaySwitchEl = document.querySelector('.overlay-switch')

		overlaySwitchEl.classList.toggle('right')
	}
	render() {
		return (
			<div className='main-container'>
				<Section id='account__section' className='height-auto'>
					<div className='col-md-6 align-self-center'>
						{/* login form */}
						<h2 style={{ zIndex: 0 }}>Welcome Back!</h2>
						<h4>Login to your account</h4>
						<form action='#' method='post'>
							<div className='form-group'>
								<label htmlFor='loginEmail'>
									Email address
								</label>
								<input
									type='email'
									className='form-control'
									id='loginEmail'
									aria-describedby='emailHelp'
									placeholder='marcela.garcia@gmail.com'
								/>
							</div>
							<div className='form-group'>
								<label htmlFor='loginPassword'>Password</label>
								<input
									type='password'
									className='form-control'
									id='loginPassword'
									placeholder='Password'
								/>
							</div>
							<div className='form-group'>
								<div className='row align-items-center'>
									<div className='col-md-6'>
										<p className='text-muted'>
											<a href='/forgot-password'>
												Forgot Password?
											</a>
										</p>
									</div>
									<div className='col-md-6'>
										<button
											type='submit'
											className='btn btn--primary btn--lg'>
											Sign In
										</button>
									</div>
								</div>
							</div>
						</form>
					</div>
					<div className='col-md-6 align-self-center'>
						{/* sign up form */}
						<h2 style={{ zIndex: 0 }}>Hi There!</h2>
						<h4>Fill out this form to join our community</h4>
						<form action='#' method='post'>
							<div className='form-group'>
								<label htmlFor='signupName'>Full Name</label>
								<input
									type='text'
									name='signupName'
									id='signupName'
									placeholder='Marcela Garcia'
								/>
							</div>
							<div className='form-group'>
								<label htmlFor='signupEmail'>Email</label>
								<input
									type='email'
									name='signupEmail'
									id='signupEmail'
									placeholder='marcela.garcia@gmail.com'
								/>
							</div>
							<div className='form-group'>
								<label htmlFor='signupPhone'>
									Phone Number
								</label>
								<input
									type='text'
									pattern='\d*'
									name='signupPhone'
									id='signupPhone'
									placeholder='(512) 456-0987'
								/>
							</div>
							<div className='form-group'>
								<label htmlFor='signupPassword'>
									Create Password
								</label>
								<input
									type='password'
									name='signupPassword'
									id='signupPassword'
									placeholder='Create Password'
								/>
								<small
									id='emailHelp'
									className='form-text text-muted'>
									Your password should be at least 8
									characters
								</small>
							</div>
							<div className='form-group'>
								<label htmlFor='signupConfirmation'>
									Confirm Password
								</label>
								<input
									type='password'
									name='signupConfirm'
									id='signupConfirm'
									placeholder='Confirm Password'
								/>
							</div>
							<div className='form-group'>
								<div className='row align-items-center'>
									<div className='col-md-6'>
										<p
											className='form-check-label'
											htmlFor='exampleCheck1'>
											I agree to the&nbsp;
											<a href='/terms-of-use'>
												Terms of Use
											</a>
										</p>
									</div>
									<div className='col-md-6'>
										<button
											type='submit'
											className='btn btn--primary btn--lg'>
											Sign Up
										</button>
									</div>
								</div>
							</div>
						</form>
					</div>
					<div className='col-md-6 overlay-switch'>
						<div className='signup-text__container align-self-center'>
							<h3>Don't have an account?</h3>
							<span className='btn' onClick={this.toggleForms}>
								<span className='btn__text'>
									Click Here to Sign Up
								</span>
							</span>
						</div>
						<div className='login-text__container align-self-center'>
							<h3>Have an account already?</h3>
							<span className='btn' onClick={this.toggleForms}>
								<span className='btn__text'>
									Click Here to Login
								</span>
							</span>
						</div>
					</div>
				</Section>
			</div>
		)
	}
}

export default LoginForms
